/**
 * Escape regular expression string for special characters.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 */
export const escapeRegex = value => {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export const liveRegex = value => /^[A-Za-z0-9_./#?:=()%&~@\-]*$/.test(value);
export const urlRegex = value => /^(?!.*--)([a-zA-Z0-9\-\_.@:]+)([\w]+\.)+([a-zA-Z0-9\-\_.\/#=():%&~]*)?(\?([\w-]+(=[\w-]+)(&[\w-]+(=[\w-]*)?)*))?$/i.test(value);
export const consecutiveDotsRegex = value => /^(?!.*?\.\.)/.test(value);
export const ipAddressRegex = value => /^(?!.*--)(((ftps?|https?):\/\/)|mailto?:)?((?!.*\.$)(1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}(:+[0-9]{1,5})?(\/[a-zA-Z0-9=?/]{1,})?$/.test(value);
export const isIntegerRegex = value => /^-?[0-9]+$/.test(`${value.replace(' ', '')}`);
export const isAlphaNumericRegex = value => /^-?[0-9a-zA-Z]+$/.test(`${value.replace(' ', '')}`);
export const countPattern = (value, pattern) => {
  const patternRegExp = new RegExp(pattern, 'g');
  return (value.match(patternRegExp) || []).length;
};
//# sourceMappingURL=regularExpression.js.map